import en from "./en-US.json"

export default {
	en,
}
